/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : FilesTable.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : ConfigTable component
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Jan 7, 2022
 *
 * @Version      : Version 1.0
 *
 * By            : <Changed By user id>
 * On            :  <Change Date>
 * Description   : <Change Description>
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { Card, Grid } from "@scuf/common";
import "./NoApmFileHistory.scss";
import { ReactComponent as NoApmIcon } from "./noApmIcon.svg";

export const NoApmFileHistory: FC = () => {
  return (
    <Card className="no-file-history">
      <Card.Content>
        <Grid>
          <Grid.Row>
            <Grid.Column className="no-file-history-icon-container">
              <NoApmIcon />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="no-file-history-text">
              {`There is no APM File. Create your first APM`}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
};
